import React from 'react';

const OurApproach = () => {
  const steps = [
    {
      title: 'Assessment',
      description: 'We begin by conducting a comprehensive assessment to evaluate your child\'s speech and language abilities. Our experienced therapists will observe and interact with your child to identify any areas of concern.',
    },
    {
      title: 'Identifying Issues',
      description: 'Based on the assessment results, our therapists will identify specific speech and language issues that need to be addressed. We will discuss our findings with you and provide a detailed report outlining the areas of focus.',
    },
    {
      title: 'Personalized Treatment Plan',
      description: 'Our team will develop a personalized treatment plan tailored to your child\'s specific needs. The plan will include a combination of therapy sessions, exercises, and activities designed to target the identified issues and promote speech and language development.',
    },
    {
      title: 'Therapy Sessions',
      description: 'Your child will attend regular therapy sessions with our skilled therapists. During these sessions, they will engage in interactive activities, exercises, and games designed to improve their speech and language skills. Our therapists will provide guidance, support, and encouragement throughout the process.',
    },
    {
      title: 'Progress Tracking',
      description: 'We will closely monitor your child\'s progress throughout the therapy program. Our therapists will regularly assess their performance and adjust the treatment plan as needed to ensure optimal results. We will keep you informed of your child\'s progress and provide you with updates and recommendations.',
    },
    {
      title: 'Continual Support',
      description: 'We are committed to providing ongoing support to ensure your child\'s success. Even after the completion of the initial therapy program, we will continue to offer guidance, resources, and follow-up sessions to help maintain and further enhance your child\'s speech and language skills.',
    },
  ];

  return (
    <div className="container mx-auto py-12">
      <h1 className="text-4xl font-bold text-center mb-12">Our Approach</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {steps.map((step, index) => (
          <div key={index} className="bg-white shadow-lg rounded-lg p-6">
            <div className="flex items-center mb-6">
              <div className="bg-primary text-white rounded-full w-12 h-12 flex items-center justify-center mr-4">
                <span className="text-2xl font-bold">{index + 1}</span>
              </div>
              <h2 className="text-2xl font-bold">{step.title}</h2>
            </div>
            <p className="text-gray-600">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurApproach;